import React from 'react';
import { UniversalLink } from '@plone/volto/components';
import { useHomeDestaques } from 'volto-ministerio-publico-federal/hooks/useHomeDestaques';
import { buildNewsFilterUrl } from 'volto-ministerio-publico-federal/hooks/useNewsFilters';
import { decodeVocabularyToken } from 'volto-ministerio-publico-federal/utils/decodeVocabularyToken';
import SidebarCard from './SidebarCard';

/** Teto de temas exibidos — a curadoria também pede no máximo 5. */
const LIMIT = 5;

/**
 * Card "Navegue por temas": pílulas que levam à listagem geral já filtrada por
 * aquele tema (`/comunicacao/noticias?tema=...`).
 *
 * A curadoria vive no mesmo lugar dos destaques — o bloco `mpfDestaques` da
 * home (campo "Temas em destaque") — para ser a mesma seleção em todas as
 * páginas de notícia. Sem tema curado, o card não aparece.
 *
 * Reusa as classes de `MPFFilterPill` (estado `enabled`) em vez do componente:
 * ali a pílula é um `<button>` de alternância, e aqui cada pílula é navegação.
 */
export const NaveguePorTemas: React.FC<{ limit?: number }> = ({
  limit = LIMIT,
}) => {
  const { temas } = useHomeDestaques();

  if (temas.length === 0) {
    return null;
  }

  return (
    <SidebarCard title="Navegue por temas">
      <ul className="mpf-news-sidebar__temas">
        {temas.slice(0, limit).map((tema) => (
          <li key={tema}>
            <UniversalLink
              href={buildNewsFilterUrl({ tema })}
              className="mpf-filter-pill mpf-filter-pill--enabled"
            >
              {decodeVocabularyToken(tema)}
            </UniversalLink>
          </li>
        ))}
      </ul>
    </SidebarCard>
  );
};

export default NaveguePorTemas;
